// extracted by mini-css-extract-plugin
export default {"container":"EmptyCard_container__mpAc7","noPad":"EmptyCard_noPad__E18qV"};